/** エラーコード → UI メッセージ（UI/UX設計書 §10.3 / 機能設計書 §9） */
export interface ApiErrorBody { code: string; message: string; details?: unknown[] }

export class ApiError extends Error {
  code: string;
  status: number;
  details: unknown[];
  constructor(status: number, body: ApiErrorBody) {
    super(body.message);
    this.status = status;
    this.code = body.code;
    this.details = (body.details ?? []) as unknown[];
  }
}

const TEMPLATES: Record<string, string> = {
  E1001: "既に登録されています",
  E1002: "メールアドレスまたはパスワードが正しくありません",
  E4001: "メールアドレスまたはパスワードが正しくありません",
  E1003: "この空間は現在満員です。少し時間を置いて再度お試しください",
  E1004: "既にお気に入りに登録されています",
  E1005: "ご購入後の商品のレビューを投稿できます",
  E1006: "在庫が不足しています",
  E1007: "注文手続きを進めることができません",
  E1008: "この操作を行う権限がありません",
  E4008: "この操作を行う権限がありません",
  E4011: "この操作を行う権限がありません",
  E1009: "キャンセル可能な期間を過ぎています",
  E1010: "クーポンコードが無効です",
  E1011: "この空間は削除できません",
  E2001: "入力内容に誤りがあります",
  E4002: "入力内容に誤りがあります",
  E4003: "セッションの有効期限が切れました。再度ログインしてください",
  E4014: "セッションの有効期限が切れました。再度ログインしてください",
  E4004: "対象が見つかりませんでした",
  E4005: "対象は削除済みです",
  E4010: "この空間への入場に失敗しました",
  E4012: "商品到着後のレビュー投稿をお待ちください",
  E4013: "サーバー側の決済確認で問題が発生しました。サポートまでご連絡ください",
  E4029: "リクエストが多すぎます。少し時間を置いてお試しください",
  E5000: "サーバーでエラーが発生しました",
};

/** E1006 は残数、E4002 はフィールド名を差し込む（§10.3 テンプレート） */
export function toUiMessage(err: unknown): string {
  if (!(err instanceof ApiError)) {
    return err instanceof Error ? err.message : "通信に失敗しました";
  }
  const base = TEMPLATES[err.code] ?? err.message;
  const first = err.details?.[0] as Record<string, unknown> | undefined;
  if (err.code === "E1006" && first && typeof first.remaining === "number") {
    return `${base}。残りは ${first.remaining} 個です`;
  }
  if (err.code === "E1011" && first) {
    if (typeof first.shops === "number") {
      return `${base}。出店中の店舗が ${first.shops} 件あります。先に店舗を移すか削除してください`;
    }
    if (typeof first.current_users === "number") {
      return `${base}。入場中の人が ${first.current_users} 人います。メンテナンスにして退出を待ってください`;
    }
  }
  if ((err.code === "E4002" || err.code === "E2001") && first && first.field) {
    return `${base}（${first.field}: ${first.message ?? ""}）`;
  }
  return base;
}
